export const BuiltIn = {
  id: 1,
  value: 'BUILT_IN',
  name: 'Built-In',
};

export const User = {
  id: 2,
  value: 'USER',
  name: 'User',
};

const Basic = [BuiltIn, User];
const BasicDefault = Basic.map(({ value }) => value);

const BasicByValue = Basic.reduce((hash, status) => {
  hash[status.value] = status;
  return hash;
}, {});

const BasicProps = Object.keys(BasicByValue);

export default {
  Basic,
  BasicDefault,
  BasicByValue,
  BasicProps,
  BuiltIn,
  User,
};
